import { PortalType } from "@studyportals/domain-client";
import { FilterType } from "@domain/enums/FilterType";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

export class EducationalLevelFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.EDUCATION_LEVEL;
	public isMultiSelect = false;
	private static instance: EducationalLevelFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{id: PortalType.MASTER, virtualPath: 'master', name: 'Master'},
		{id: PortalType.BACHELOR, virtualPath: 'bachelor', name: 'Bachelor'},
		{id: PortalType.PHD, virtualPath: 'phd', name: 'PhD'},
		{id: PortalType.SHORT, virtualPath: 'course', name: 'Short course'},
		{id: PortalType.DISTANCE_LEARNING, virtualPath: 'distance-learning', name: 'Online'},
	];

	public static getInstance(): EducationalLevelFilterMapper {
		if (!EducationalLevelFilterMapper.instance) {
			EducationalLevelFilterMapper.instance = new EducationalLevelFilterMapper();
		}
		return EducationalLevelFilterMapper.instance;
	}

	private constructor() {
		super();
	}
}
